import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/custom/schedule/export`,
      method: 'GET',
    }),
  });

interface Body {
  tournamentId: number;
}

interface Response {
  data: {
    url: string;
  };
  code: number;
}
